void main() {
    vec3 baseColor = vec3(0.1843, 0.4157, 1.0);
    gl_FragColor = vec4(baseColor, 0.35);
}


